import script from "./Dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=cb514a6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb514a6c"]])

export default __exports__